import { render, staticRenderFns } from "./IllustrateCom.vue?vue&type=template&id=ef8ba810&scoped=true"
import script from "./IllustrateCom.vue?vue&type=script&lang=js"
export * from "./IllustrateCom.vue?vue&type=script&lang=js"
import style0 from "./IllustrateCom.vue?vue&type=style&index=0&id=ef8ba810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ba810",
  null
  
)

export default component.exports